module.exports = __webpack_public_path__ + "static/media/JA_My_Way.6938ea7a.png";